// extracted by mini-css-extract-plugin
export default {"titleWrapper":"TitleWrapper_titleWrapper__4WkjG","title":"TitleWrapper_title__D2BZV","description":"TitleWrapper_description__meFFo"};